import createTableStore from "ds/components/Table/store/useTableStore";

import { SERVICE_NOW_TABLE_COLUMNS_CONFIG, SERVICE_NOW_TABLE_STORAGE_KEY } from "./constants";

const useServiceNowTableStore = createTableStore({
  storageKey: SERVICE_NOW_TABLE_STORAGE_KEY,
  config: SERVICE_NOW_TABLE_COLUMNS_CONFIG,
});

export default useServiceNowTableStore;
